import React from 'react';
import './B1.css';

const B1: React.FC = () => {
  const cards = [
    { title: 'Intermediate Skills', subtitle: 'Bridge understanding', badge: 'B1', bg: '#5EEAD4' },
    { title: 'Dialogues', subtitle: 'Speak freely', badge: 'B1', bg: '#3B82F6' },
    { title: 'Grammar', subtitle: 'Grammar in action', badge: 'B1', bg: '#EF4444' },
    { title: 'Stories', subtitle: 'Read & interpret', badge: 'B1', bg: '#9333EA' },
  ];

  return (
    <div className="level-wrapper">
      <h1 className="level-title">B1 - Intermediate Level</h1>
      <div className="level-grid">
        {cards.map((card, index) => (
          <div key={index} className="level-card" style={{ backgroundColor: card.bg }}>
            <div className="level-badge">{card.badge}</div>
            <div className="level-content">
              <h2>{card.title}</h2>
              <p>{card.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default B1;
